import { BaseProxy } from '../base.proxy';
import { Injectable } from '@angular/core';
import { PositionGridConfig } from '../../model/portfolio/IPositionGridConfig.model';
import { environment } from 'src/environments/environment';

@Injectable()
export class PositionProxy extends BaseProxy {
  getProgramPositions(programId: number, asOfDate: Date) {
    if (environment.feature.newApi === false) {
      return this._http.get<any>(
        `/ip/api/account/portfolio/program/${programId}/positions?asOfDate=${this.getDateStr(
          asOfDate
        )}`
      );
    } else {
      return this._http.get<any>(
        `/ip-api/api/portfolio/program/${programId}/positions?asOfDate=${this.getDateStr(
          asOfDate
        )}`
      );
    }
  }

  getProgramPositionLastAsOfDate(programId: number) {
    if (environment.feature.newApi === false) {
      return this._http.get<string>(
        `/ip/api/account/portfolio/program/${programId}/position/date/last`
      );
    } else {
      return this._http.get<string>(
        `/ip-api/api/portfolio/program/${programId}/position/date/last`
      );
    }
  }

  getProgramPositionAsOfDate(programId: number, asOfDate: Date) {
    if (environment.feature.newApi === false) {
      return this._http.get<string>(
        `/ip/api/account/portfolio/program/${programId}/position/date?date=${this.getDateStr(
          asOfDate
        )}`
      );
    } else {
      return this._http.get<string>(
        `/ip-api/api/portfolio/program/${programId}/position/date?date=${this.getDateStr(
          asOfDate
        )}`
      );
    }
  }

  getProgramPositionTableConfiguration(programId: number) {
    if (environment.feature.newApi === false) {
      return this._http.get<PositionGridConfig>(
        `/ip/api/account/portfolio/program/${programId}/position/table/configuration`
      );
    } else {
      return this._http.get<PositionGridConfig>(
        `/ip-api/api/portfolio/program/${programId}/position/table/configuration`
      );
    }
  }

  saveProgramPositionOrders(programId: number, columns: any[]) {
    if (environment.feature.newApi === false) {
      return this._http.post(
        `/ip/api/account/portfolio/program/${programId}/column/order`,
        columns
      );
    } else {
      return this._http.post(
        `/ip-api/api/portfolio/program/${programId}/column/order`,
        columns
      );
    }
  }

  saveProgramPositionGroups(programId: number, columns: any[]) {
    if (environment.feature.newApi === false) {
      return this._http.post(
        `/ip/api/account/portfolio/program/${programId}/column/group`,
        columns
      );
    } else {
      return this._http.post(
        `/ip-api/api/portfolio/program/${programId}/column/group`,
        columns
      );
    }
  }

  getReportUserProgramITDEnd(
    programId: number,
    instanceId: number,
    accountId: number
  ) {
    if (environment.feature.newApi === false) {
      return this._http.get<string>(
        `/ip/api/account/portfolio/program/${programId}/instance/${instanceId}/crmAccount/${accountId}/itd/end`
      );
    } else {
      return this._http.get<string>(
        `/ip-api/api/portfolio/program/${programId}/instance/${instanceId}/crmAccount/${accountId}/itd/end`
      );
    }
  }
}
